const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4094ce44a919648fa8721d5bd3b574eca0c4495f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["next@themecloud-o0"]={id:"4094ce44a919648fa8721d5bd3b574eca0c4495f"};
      